// @flow
import styled from "styled-components";
import { media } from "@nested/ui";

const SubMenu = styled.ul`
  list-style-type: none;
  margin: 0px;
  padding: 0px;
  margin-bottom: 40px;

  ${media.tablet`
    &:before {
      width: 0px;
      height: 0px;
      border-bottom: 10px solid white;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      position: absolute;
      top: -10px;
      left: 50%;
      content: "";
      transform: translateX(-50%);
    }

    li:last-child > a {
      margin-bottom: 0px;
    }

    visibility: hidden;
    opacity: 0;
    transform: translateX(-50%)
               scale(0.9)
               rotateX(-45deg)
               translate3d(0, 10px, 10px);

    transform-origin: 50% -50px;

    transition: transform 250ms ease,
                opacity 200ms linear,
                visibility 250ms linear;

    position: absolute;
    left: 50%;
    top: calc(100% - 20px);

    background-color: white;
    padding: 14px;
    border-radius: 2px;
    box-shadow: 0 4px 8px 0 rgba(34, 34, 34, 0.09);
  `};
`;

export default SubMenu;
